"use strict";

module.exports = require("../../s3.fine-uploader/s3.fine-uploader.core");



/*****************
 ** WEBPACK FOOTER
 ** ./~/fine-uploader/lib/core/s3.js
 ** module id = 666
 ** module chunks = 0
 **/